import styled from "styled-components";
import BackgroundImage from "../../Assets/BG.svg";
import BackgroundImage2 from "../../Assets/bg/bottom_every.png";
import { Container } from "../../Components/Common";

export const MainWrapper = styled.div`
  width: "100vw";
  background-color: #060310;
`;

export const HeroSectionWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding-top: 200px;
  /* min-height : fit-content ; */
  background-image: url(${BackgroundImage}), url(${BackgroundImage2});
  background-size: 120vw 120vw , 130vw 120vw;
  background-position: top, bottom;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardsContainer = styled(Container)`
  margin : 40px auto;
  width : 65%;
  @media screen and (max-width : 1400px){
    width : 100%;
  }
`